export default __webpack_public_path__ + "static/media/XamôdæsBW.3ddb480d.png";